import {Pipe, PipeTransform} from '@angular/core';
import {Stammdatum} from '../dtos/stammdatum';

@Pipe({
  name: 'retrieveCaption',
  standalone: false
})
export class RetrieveCaptionFromArrayPipe implements PipeTransform {
  transform(value: string, functions: Stammdatum[]): string {
    return retrieveCaptionFromArray(value, functions);
  }
}

export function retrieveCaptionFromArray(
  value: string,
  functions: Stammdatum[]
): string {
  const result = functions.find(p => p.value === value);
  return result?.caption || value || '';
}
